//@author: mandy
import { ChangeDetectionStrategy, Component, NgZone, OnInit, ViewEncapsulation } from "@angular/core";
import { DropDownItem } from "../../../pojo/DropDownItem";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { SpaceService } from "../../../services/space.service";
import { S25DropdownAbstract } from "../s25.dropdown.abstract";

@TypeManagerDecorator("s25-partition-dropdown")
@Component({
    selector: "s25-partition-dropdown",
    template: `
        @if (items) {
            <s25-generic-dropdown
                [value]="value()"
                [onSelect]="onSelect"
                [items]="items"
                [staticItems]="staticItems"
                [autoOpen]="autoOpen"
                [alwaysOpen]="alwaysOpen"
                [hideSearch]="hideSearch"
                [focusFirst]="false"
                [searchEnabled]="true"
                [apiBean]="apiBean"
                [placeholder]="''"
                [resetSelectedOnCleanup]="resetSelectedOnCleanup"
                [ariaLabel]="ariaLabel"
                (valueChange)="onValueChange($event)"
            />
        }
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class S25PartitionDropdownComponent extends S25DropdownAbstract implements OnInit {
    constructor(private zone: NgZone) {
        super();
    }

    ngOnInit() {
        SpaceService.getLocationPartitions().then((data: DropDownItem[]) => {
            this.zone.run(() => {
                this.staticItems = [
                    {
                        dropDownOrigName: "No Partition",
                        isSelected: true,
                        itemId: 0,
                        itemName: "No Partition",
                        noAnchorClick: true,
                        txt: "No Partition",
                        val: "",
                    },
                ];
                this.items = data;
                this.onLoad && this.onLoad();
                this.cd.detectChanges();
            });
        });
    }
}
